import { api } from "../axios";

export const completeSchedule = async (consultationId?: string) => {
  const { data } = await api.post<null>(
    `/v1/patients/consultations/${consultationId}/schedule-appointment`,
  );
  return data;
};
